import React from 'react';
import { formatOverdue, formatTime, whereabouts } from '../../lib/ihsanRollStore';
import { StatusDot } from './shared';

export default function WhereaboutsView({ store, onOpenCase }) {
  const board = whereabouts(store);
  return (
    <div className="px-4 pt-5 pb-8" data-testid="ihsanroll-whereabouts">
      <h1 className="text-2xl font-extrabold text-[#0F172A]">Whereabouts</h1>
      <p className="text-sm text-muted-foreground mt-1" aria-live="polite">
        In: {board.inCount} · Out: {board.out} · Overdue: {board.overdue}
      </p>

      {!board.open.length && (
        <p className="mt-6 text-sm text-muted-foreground">Everyone is in right now.</p>
      )}

      <div className="mt-4 flex flex-col gap-2">
        {board.open.map((entry) => (
          <button
            key={entry.id}
            type="button"
            data-testid={`ihsanroll-where-${entry.caseNo}`}
            onClick={() => onOpenCase(entry.caseNo)}
            className={`rounded-2xl border p-4 text-left ${
              entry.overdue ? 'border-[#D64545]/40 bg-red-50' : 'border-amber-300 bg-amber-50'
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <span className={`text-base font-extrabold ${entry.overdue ? 'text-[#D64545]' : 'text-[#0F172A]'}`}>
                Case #{entry.caseNo}
              </span>
              <StatusDot status={entry.overdue ? 'overdue' : 'out'} />
            </div>
            <p className={`text-sm mt-1 ${entry.overdue ? 'text-[#D64545]' : 'text-[#0F172A]'}`}>
              {entry.place}
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Out {formatTime(entry.time)} · expected {formatTime(entry.expectedReturn)} · {entry.authorisedBy}
            </p>
            {entry.overdue && (
              <p className="text-xs font-bold text-[#D64545] mt-1">{formatOverdue(entry.overdueMs)}</p>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
